import { NAME_SPACE } from './config';
import DownloadAccordion from './components/download-accordion.component.vue';

export default {
    name: NAME_SPACE,
    components: {
        'download-accordion': DownloadAccordion,
    },
};
